module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_1.4701e86b.png";